import { useId } from 'react';

import { Box, ProgressStepper, ShowHide } from '@zillow/constellation-10';

export type Signee = {
  type: string;
  text: string;
};
type Props = {
  signeeList: Array<Signee>;
};

const WhoHasSignedDescription = ({ signeeList }: Props) => {
  const showHideId = useId();

  function renderExpandedContent(): JSX.Element | null {
    if (signeeList == null) {
      return null;
    }

    const isComplete = signeeList.every((signee) => signee.type !== 'unsigned');

    const steps = signeeList.map((signee) => ({
      label: signee.text,
      tone: signee.type !== 'unsigned' ? 'complete' : null,
    }));

    return (
      <ProgressStepper activeStepIndex={isComplete ? signeeList?.length : -1} orientation="vertical" steps={steps} />
    );
  }

  return (
    <>
      {signeeList?.length > 0 && (
        <ShowHide.Root id={showHideId} defaultHidden={false} renderButton={() => null}>
          <div>
            <ShowHide.Button aria-controls={showHideId} css={{ marginBlockStart: '0' }}>
              Who has signed?
            </ShowHide.Button>
            <ShowHide.Hidden>
              <Box css={{ marginBlockStart: '400' }}>{renderExpandedContent()}</Box>
            </ShowHide.Hidden>
          </div>
        </ShowHide.Root>
      )}
    </>
  );
};

export default WhoHasSignedDescription;
